import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CreditCardIcon from "@mui/icons-material/CreditCard";

export default function PaymentMethodDialog({
  open,
  onClose,
  selectedPlan,
  onConfirmPayment,
  loading,
}) {
  const [paymentMethod, setPaymentMethod] = useState("card");

  const handleSubmit = () => {
    onConfirmPayment(selectedPlan, paymentMethod);
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant='h6' fontWeight='bold'>
          {/* Select Payment Method */}
          Initiate Payment
        </Typography>

        <IconButton onClick={onClose} disabled={loading} size='small'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {selectedPlan && (
          <Box
            sx={{
              mb: 2,
              p: 2,
              bgcolor: "#f5f5f5",
              borderRadius: 1,
            }}
          >
            <Typography variant='subtitle2' color='text.secondary'>
              Selected Plan: <strong>{selectedPlan.title}</strong>
            </Typography>

            <Typography variant='h6' color='primary' fontWeight='bold'>
              {selectedPlan.price}
            </Typography>
          </Box>
        )}

        <RadioGroup
          value={paymentMethod}
          onChange={(event) => setPaymentMethod(event.target.value)}
        >
          <Paper
            variant='outlined'
            onClick={() => setPaymentMethod("psid")}
            sx={{
              p: 2,
              mb: 1.5,
              cursor: "pointer",
              borderColor: paymentMethod === "psid" ? "#003D78" : "divider",
              borderWidth: paymentMethod === "psid" ? 2 : 1,
            }}
          >
            <FormControlLabel
              value='psid'
              control={<Radio color='primary' />}
              label={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <ReceiptLongIcon color='primary' />

                  <Box>
                    <Typography variant='subtitle2' fontWeight='bold'>
                      Pay via PSID / 1Bill
                    </Typography>

                    <Typography variant='caption' color='text.secondary'>
                      Pay through Mobile Banking, ATM, or Over the Counter
                    </Typography>
                  </Box>
                </Box>
              }
            />
          </Paper>

          {/* <Paper
            variant='outlined'
            onClick={() => setPaymentMethod("card")}
            sx={{
              p: 2,
              cursor: "pointer",
              borderColor: paymentMethod === "card" ? "#003D78" : "divider",
              borderWidth: paymentMethod === "card" ? 2 : 1,
            }}
          >
            <FormControlLabel
              value='card'
              control={<Radio color='primary' />}
              label={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <CreditCardIcon color='primary' />

                  <Box>
                    <Typography variant='subtitle2' fontWeight='bold'>
                      Credit / Debit Card
                    </Typography>

                    <Typography variant='caption' color='text.secondary'>
                      Pay via Visa, MasterCard, or UnionPay
                    </Typography>
                  </Box>
                </Box>
              }
            />
          </Paper> */}
        </RadioGroup>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={loading} color='inherit'>
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          variant='contained'
          disabled={loading}
          sx={{
            backgroundColor: "#003D78",
            minWidth: 120,
          }}
        >
          {loading ? <CircularProgress size={24} color='inherit' /> : "Proceed"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
